exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-warnning-texted{background-color:rgba(0,0,0,0) !important;-webkit-box-shadow:none !important;box-shadow:none !important;border:none !important;border:1px solid #e5eef1;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:8px;margin-top:20px;text-align:center}.content-warnning-texted h2{font-family:\"Segoe UI\",sans-serif;font-style:normal;font-weight:normal;font-size:24px;line-height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;color:#091c4b;margin-top:-70px}.content-warnning-texted .button{margin-top:30px}", ""]);

// exports
